import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../../AutoFocus'
import buttonStyle from 'Styles/button.css'

import style from './style.css'

import closeImg from 'Assets/x-icon-white.svg'

function closeButton () {
  return (
    <img
      src={closeImg}
      alt="Close score value info"
      className={style.closeIcon}
    />
  )
}

export default function ScoreValue (props) {
  const { lessThan } = props.browser
  let copy = (
    <AutoFocus>
      You have <span className={style.largeNumber}>{props.score.activityScore}</span> out
      of <span className={style.largeNumber}>{props.score.scoreTarget}</span> points
      needed to complete this activity.
    </AutoFocus>
  )

  if (props.complete) {
    copy = (
      <AutoFocus>
        You have completed the activity, but you may continue to answer questions as long as you like.
      </AutoFocus>
    )
  }
  const previewSpacer = props.isPreview ? style.previewSpacer : ''

  return (
    <div className={classnames(style.scoreInfo, previewSpacer)}>
      <button
        className={classnames(buttonStyle.rectangle, style.hideInfo)}
        onClick={props.onClick}
      >
        {lessThan.medium ? closeButton() : 'Hide Tip'}
      </button>
      {copy}
    </div>
  )
}

ScoreValue.propTypes = {
  browser: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  score: PropTypes.object.isRequired,
  complete: PropTypes.bool.isRequired,
  isSplitScreenEbookDisplayed: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired
}
